export const topBar = {
  hi: 'Hello, {{username}}',
  accountSetting: 'Account setting',
}
